<template>
  <div class="lk-burger-menu" :class="{ 'lk-burger-menu--visible': visible && isLkMobile }">
    <ul class="lk-burger-menu__list">
      <li v-for="(menuItem, idx) in menu" :key="menuItem.name" class="lk-burger-menu__item">
        <template v-if="hasSubMenu(menuItem)">
          <button
            type="button"
            :class="[
              'lk-burger-menu__menu-btn',
              {
                'lk-burger-menu__menu-btn--active': isMenuItemActive(menuItem),
                'lk-burger-menu__menu-btn--expanded': activeMenuIdx === idx,
              },
            ]"
            :aria-label="menuItem.name"
            :aria-expanded="activeMenuIdx === idx ? 'true' : 'false'"
            aria-haspopup="true"
            @click="toggleActiveMenuIdx(idx)"
          >
            <span>{{ menuItem.name }}</span>
            <ArrowSmallDown :class="['lk-burger-menu__arrow', { 'lk-burger-menu__arrow--expanded': activeMenuIdx === idx }]" />
          </button>

          <transition @enter="enterSubmenu" @after-enter="afterEnterSubmenu" @leave="leaveSubmenu">
            <ul v-if="activeMenuIdx === idx" class="lk-burger-menu__sub-menu" role="menu">
              <li v-for="submenu in menuItem.submenu" :key="submenu.name" class="lk-burger-menu__sub-menu-item">
                <AppLink
                  class="lk-burger-menu__menu-link lk-burger-menu__menu-link--submenu lk-burger-menu__sub-menu-link"
                  :to="submenu.link"
                  open-external-in-current-tab
                  @click.native="handleLinkClick"
                >
                  {{ submenu.name }}
                </AppLink>
              </li>
            </ul>
          </transition>
        </template>

        <template v-else>
          <AppLink class="lk-burger-menu__menu-link" :to="menuItem.link" open-external-in-current-tab @click.native="handleLinkClick">
            {{ menuItem.name }}
          </AppLink>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ArrowSmallDown from '@assets/lk/icons/arrow-small-down.svg?inline'

export default {
  name: 'LkTabletMenu',
  components: {
    ArrowSmallDown,
  },
  model: {
    prop: 'visible',
    event: 'input',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    menu: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeMenuIdx: null,
    }
  },
  computed: {
    ...mapState('mobile', ['isLkMobile']),
    ...mapGetters('lk', ['profile', 'linkLogout']),
  },
  watch: {
    $route() {
      this.closeAllMenus()
    },
  },
  methods: {
    hasSubMenu(item) {
      return Array.isArray(item?.submenu) && item.submenu.length > 0
    },
    isRouteActive(routeName) {
      return Boolean(routeName) && this.$route.name === routeName
    },
    isMenuItemActive(menuItem) {
      if (this.hasSubMenu(menuItem)) {
        return menuItem.submenu.some(submenuItem => this.isRouteActive(submenuItem?.link))
      }

      return this.isRouteActive(menuItem?.link)
    },
    toggleActiveMenuIdx(idx) {
      this.activeMenuIdx = this.activeMenuIdx === idx ? null : idx
    },
    handleLinkClick() {
      this.$emit('input', false)
      this.closeAllMenus()
    },
    closeAllMenus() {
      this.activeMenuIdx = null
    },
    enterSubmenu(el) {
      el.style.height = '0'
      el.style.overflow = 'hidden'

      requestAnimationFrame(() => {
        el.style.height = `${el.scrollHeight}px`
      })
    },
    afterEnterSubmenu(el) {
      el.style.height = 'auto'
      el.style.overflow = ''
    },
    leaveSubmenu(el) {
      el.style.height = `${el.scrollHeight}px`
      el.style.overflow = 'hidden'

      requestAnimationFrame(() => {
        el.style.height = '0'
      })
    },
  },
}
</script>

<style lang="sass">
@import "~@src/assets/lk/styles/variables"

.lk-burger-menu
  position: fixed
  padding: 32px
  inset: 0
  top: var(--header-height)
  z-index: 999
  background-color: $dark-blue
  transform: translateX(-100%)
  transition: transform .3s
  will-change: transform
  border-top: 1px solid rgba($shades-black, .24)
  overflow-y: auto

  &::-webkit-scrollbar
    display: none

  &.lk-burger-menu--visible
    transform: translateX(0)

  &__list
    display: flex
    gap: 16px
    flex-direction: column
    align-items: normal
    font-size: 14px
    font-weight: 600

  &__item
    border-radius: 16px
    overflow: hidden

  &__sub-menu
    background-color: #484F67
    padding-bottom: 6px
    transition: height .28s cubic-bezier(.645, .045, .355, 1)

  &__menu-link
    display: inline-flex

  &__menu-btn, &__menu-link
    width: 100%
    padding: 16px 21px
    background-color: #484F67

    &--active
      color: $bright-blue

  &__menu-link--submenu
    padding: 10px 21px

  &__menu-btn
    display: flex
    align-items: center
    justify-content: space-between
    border: 0
    text-align: left
    cursor: pointer
    color: #fff

    &--expanded
      padding-bottom: 10px

  button.lk-burger-menu__menu-btn--active
    color: $bright-blue

  &__arrow
    transition: transform .3s
    will-change: transform
    width: 20px
    margin-top: 2px

    &--expanded
      transform: rotate(180deg)
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/lk/header/components/LkBurgerMenu.vue